<mat-card class="my-3 shadow-none">
  <div class="label-holder">
    <span class="content-label" translate>Generate promocode</span>
  </div>

  <div class="form-container">
    <form (ngSubmit)="onPromoCodeSubmit()" class="px-0" [formGroup]="generatePromoForm">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="content-details-blk shadow py-3">
            <div class="row my-2">
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Promocode' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <input matInput type="text" formControlName="promoCode" placeholder="Enter promoCode" required />
                  </mat-form-field>
                  <div *ngIf="f.promoCode.touched && f.promoCode.invalid">
                    <div *ngIf="f.promoCode.errors.required">
                      <mat-hint class="text-danger ms-2">
                        promoCode is required.</mat-hint>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Country' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="country" required readonly>
                      <mat-option *ngFor="let item of promotionsCountries" [value]="item.countryName">
                        {{ item.countryName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="f.country.touched && f.country.invalid">
                    <div *ngIf="f.country.errors.required">
                      <mat-hint class="text-danger ms-2">
                        country is required.</mat-hint>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="row my-2">
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{ 'pages.RealtimeTransactions.Product' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="product" [(value)]="selectedcodegroups" multiple required>
                      <mat-option #allSelected (click)="toggleAllSelection()" [value]="0" class="first-option">
                      </mat-option>
                      <mat-option *ngFor="let item of promotionscodeGroups" [value]="item"
                        (click)="tosslePerOne(allSelected)">
                        {{ item }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                </div>
              </div>


              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  pages.newRetailer.carrier<span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="carrier" [(value)]="selectedCarriers" multiple required>
                      <mat-option #allCarrierSelected (click)="toggleAllCarrierSelect()" [value]="0"
                        class="first-option"></mat-option>
                      <mat-option *ngFor="let item of promotionsCarriers" [value]="item"
                        (click)="toggleCarrierSelect(allCarrierSelected)">
                        {{ item }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="f.carrier.touched && f.carrier.invalid">
                    <div *ngIf="f.carrier.errors.required">
                      <mat-hint class="text-danger ms-2">
                        carrier is required.</mat-hint>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  pages.newRetailer.amount <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="row g-0">
                  <div class="col-5 me-3">
                    <div class="form-item-input">
                      <mat-form-field class="w-100 amnt-holder" appearance="outline">
                        <span class="mat-preffix" matPrefix>$&nbsp;</span>
                        <input matInput type="number" formControlName="amount1" (keyup)="checkDiscountValidation($event)" required
                          placeholder="{{'pages.placeholders.Min' | translate }}" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-item-input">
                      <mat-form-field class="w-100 amnt-holder" appearance="outline">
                        <span class="mat-preffix" matPrefix>$&nbsp;</span>
                        <input matInput type="number" formControlName="amount2" (keyup)="checkDiscountValidation($event)" required
                          placeholder="{{'pages.placeholders.Max' | translate }}" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Discount <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="row g-0">
                  <div class="col-5 me-3">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <mat-select formControlName="discount" required placeholder="type">
                          <mat-option value="$"> $ </mat-option>
                          <mat-option value="%"> % </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-5 me-3">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <input matInput type="number" formControlName="discountValue" required />
                      </mat-form-field>
                      <mat-error
                      *ngIf="showDiscountError">
                      Exceeds min amount</mat-error>
                    </div>
                  </div>
                  <span class="info-text"><i class="mi mi-info"></i> Discount to be
                    entered in % or $</span>
                </div>
              </div>

            </div>


            <div class="row my-2">
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Validity' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="row g-0">
                  <div class="col-5 me-3">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <input matInput [matDatepicker]="picker" formControlName="fromDate"
                          placeholder="{{'pages.Creditlinereport.From' | translate }}" required />
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-5">
                    <div class="form-item-input">
                      <mat-form-field class="w-100" appearance="outline">
                        <input matInput [matDatepicker]="picker1" formControlName="toDate"
                          placeholder="{{'pages.Creditlinereport.To' | translate }}"  [min]="
                          generatePromoForm.controls['fromDate'].value
                        " required />
                        <mat-datepicker-toggle matSuffix [for]="picker1">
                          <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.placeholders.Redeemlimit' | translate }}<span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field class="" appearance="outline">
                    <input matInput type="text" required placeholder="Enter Redeem Limit" formControlName="redeemLimit"
                      required />
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="row my-2">
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.PromotionCarrierPromotions.Description' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <textarea matInput required formControlName="description" placeholder="Description"
                      class="text-area">
                    </textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="form-footer my-2">
              <ng-container *ngIf="!promotionData;else managePromo">
                <ul class="list-inline text-center">
                  <li class="list-inline-item">
                    <button mat-raised-button [disabled]="!generatePromoForm.valid" color="primary" type="submit"
                      (click)="generateSend()">
                      <span translate class="translate">Generate & Send</span>
                    </button>
                  </li>
                  <li class="list-inline-item">
                    <button mat-stroked-button color="primary" type="submit" (click)="saveContinue()">
                      <span translate class="translate">Save & Continue Later</span>
                    </button>
                  </li>
                  <li class="list-inline-item">
                    <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
                      <span translate class="translate">{{ 'pages.newRetailer.cancel' | translate }}</span>
                    </button>
                  </li>
                  <li class="list-inline-item"></li>

                </ul>
              </ng-container>
              <ng-template #managePromo>
                <!-- <ng-container *ngIf="editStatus"> -->
                  <ul class="list-inline text-center">
                    <li class="list-inline-item">
                      <button mat-raised-button [disabled]="!generatePromoForm.valid || showDiscountError" color="primary" type="submit"
                        (click)="save()">
                        <span translate class="translate">Save</span>
                      </button>
                    </li>
                  </ul>
                <!-- </ng-container> -->
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</mat-card>